export enum BadgeTypeEnum {
  SUCCESS = 'success'
}
